{
  "list": {
    "attributes": {
      "friendlyName": "Nombre",
      "type": "Tipo",
      "serialNumber": "Número de serie",
      "firmwareVersion": "Versión de software",
      "hardwareVersion": "Versión de hardware",
      "state": "Estado",
      "createdAt": "Fecha de creación",
      "connectivity": {
        "name": "Conectividad",
        "connected": {
          "lessThan": "El equipo se conectó hace menos de {duration}.",
          "greaterThan": "El equipo se conectó hace más de {duration}."
        },
        "duration": {
          "seconds": "{count} segundo | {count} segundo | {count} segundos",
          "minutes": "{count} minuto | {count} minuto | {count} minutos",
          "hours": "{count} hora | {count} hora | {count} horas"
        }
      },
      "metastatus": {
        "name": "Metaestado",
        "status": {
          "success": "Todas las últimas operaciones de este equipo se han realizado correctamente.",
          "mixed": "Al menos una de las últimas operaciones de este equipo está en error.",
          "error": "Todas las últimas operaciones de este equipo están en error."
        }
      },
      "sector": "Red",
      "actionInProgress": "Acciones en curso",
      "certificateExpirationRange": "Certificado"
    }
  },
  "stateValue": {
    "PREPROVISIONED": "Presuministrado",
    "REGISTERED": "Guardado"
  },
  "import": {
    "title": "Importar",
    "text": "Importar",
    "header": {
      "text": "Importar equipos presuministrados"
    },
    "clickToUpload": "Haga clic para seleccionar",
    "orDragAndDrop": "o arrastre y suelte un archivo .ZIP",
    "action": {
      "report": "Analizar",
      "execution": "Importar"
    },
    "inProgress": {
      "report": "Análisis en curso...",
      "execution": "Importación en curso..."
    },
    "results": {
      "report": {
        "total": "No se ha detectado ningún equipo | 1 equipo detectado | {count} equipos detectados",
        "succeed": {
          "exist": "Equipos validados para actualización:",
          "new": "Equipos validados para crear:"
        },
        "failed": "Equipos en fallo:"
      },
      "execution": {
        "total": "No se trató ningún equipo | 1 equipo tratado | {count} equipos tratados",
        "succeed": {
          "exist": "Equipos actualizados:",
          "new": "Equipos creados:"
        },
        "failed": "Equipos en fallo:"
      }
    },
    "validation": {
      "fileMandatory": "El archivo debe ser un .ZIP",
      "fileEmpty": "El archivo .ZIP no debe estar vacío"
    }
  },
  "form": {
    "description": {
      "title": "Descripción",
      "idCard": {
        "title": "DNI",
        "attributes": {
          "name": "Nombre",
          "type": "Tipo",
          "model": "Gama",
          "serialNumber": "Número de serie",
          "hardwareVersion": "Versión de hardware",
          "manufacturer": "Fabricante",
          "sector": "Sector"
        }
      },
      "state": {
        "title": "Estado",
        "attributes": {
          "state": "Estado",
          "firstConnection": "Primera conexión",
          "lastConnection": "Última conexión",
          "batteryStatus": "Estado de la batería",
          "lastChange": "Último cambio",
          "configurationApplicationDate": "Fecha de aplicación de la configuración",
          "lastRebootDate": "Fecha del último reinicio",
          "firstCommissioningDate": "Fecha de la primera puesta en servicio",
          "certificateExpirationDate": "Fecha de caducidad del certificado",
          "firmwareVersion": "Versión de firmware",
          "latestFirmwareUpdate": "Última actualización del firmware",
          "lastCertificateUpdate": "Última actualización del certificado",
          "lastSynchronisation": "Última sincronización del equipo:",
          "lastDisconnectionDate": "Fecha de la última desconexión"
        }
      },
      "connectivity": {
        "title": "Conectividad",
        "communication": "Comunicación",
        "simCard": "Tarjeta SIM",
        "attributes": {
          "antenna": "Antena",
          "mobileNetwork": "Red móvil",
          "gsmFrequencyBand": "Banda de frecuencia GSM",
          "communicationProtocol": "Protocolo de comunicación",
          "accessPointName": "Nombre del punto de acceso (APN)",
          "userName": "Nombre de usuario"
        },
        "status": "Estado de conectividad"
      },
      "geolocation": {
        "title": "Descripción del sitio",
        "attributes": {
          "address": "Dirección",
          "latlong": "Latitud: {latitude} - Longitud: {longitude}",
          "status": "Geolocalización"
        }
      },
      "characteristics": {
        "title": "Características"
      }
    },
    "configuration": {
      "title": "Configuración",
      "information": {
        "configurationType": {
          "label": "Tipo de configuración",
          "SELF_SUPPORTING": "Autónoma",
          "GLOBAL_AND_SPECIFIC": "Global y específica"
        },
        "selfSupportingVersion": "Versión autónoma",
        "globalVersion": "Versión global",
        "specificVersion": "Versión específica",
        "configurationOrigin": "Origen de la configuración",
        "lastUpdate": "Última actualización"
      },
      "operations": {
        "title": "Operaciones"
      },
      "upload": {
        "userInformation": {
          "title": "Carga de configuración",
          "description": "Esta configuración solo estará disponible para este equipo."
        },
        "error": {
          "invalidFileType": "El archivo debe tener el formato JSON o JWT.",
          "fileSize": "El archivo de configuración debe tener menos de 750 MB.",
          "emptyFile": "El archivo de configuración no puede estar vacío.",
          "fileAlreadyExist": "Este archivo de configuración ya existe para este equipo."
        },
        "title": "Carga de configuración",
        "confirm": {
          "title": "Cancelación de la carga de configuración",
          "message": "¿Seguro que desea cancelar la carga de la configuración?\nTodos los datos se perderán."
        },
        "form": {
          "title": "Información de la configuración",
          "versionName": "Nombre de la versión",
          "version": "Versión",
          "type": "Tipo"
        },
        "buttonTooltip": "Cargar una configuración",
        "success": "La carga de la configuración se ha realizado correctamente."
      },
      "update": {
        "title": "Actualización de configuración",
        "warning": "El equipo ya tiene programada o en curso una operación del mismo tipo.",
        "scheduling": {
          "title": "Programación",
          "label": "Programación de la actualización",
          "placeholder": "Seleccione una fecha de actualización"
        },
        "configurationSelection": {
          "title": "Configuración",
          "radio": {
            "specific": "Específica",
            "globalAndSpecific": "Global y específica"
          },
          "label": "Seleccione una configuración en la siguiente lista.",
          "placeholder": "Seleccione una configuración",
          "specific": "Configuración específica",
          "global": "Configuración global"
        },
        "instantSending": {
          "label": "Entrega instantánea",
          "tooltip": "Transmisión de la operación al equipo lo antes posible."
        },
        "cancel": {
          "confirm": {
            "title": "Cancelación de la actualización de la configuración",
            "message": "¿Seguro que desea cancelar la actualización de la configuración? Se perderán todos los datos."
          }
        }
      },
      "browse": {
        "selfSupporting": "Buscar las configuraciones autónomas",
        "specific": "Buscar configuraciones específicas"
      },
      "list": {
        "title": {
          "selfSupporting": "Configuraciones autónomas",
          "specific": "Configuraciones específicas"
        },
        "search": {
          "placeholder": "Buscar por versión o nombre de la versión"
        },
        "noConfiguration": "No se ha encontrado ninguna configuración.",
        "columns": {
          "versionName": "Nombre de la versión",
          "version": "Versión",
          "uploadedDate": "Fecha de carga"
        },
        "periodPicker": {
          "placeholder": "Seleccione un periodo"
        }
      }
    },
    "dataviz": {
      "title": "Visualización de los datos",
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "quarter": "Trimestre",
      "newChart": "Deslice y coloque un dato aquí para crear un nuevo gráfico.",
      "noData": "Ningún dato"
    },
    "firmware": {
      "title": "Firmware",
      "state": {
        "attributes": {
          "firmwareVersion": "Versión",
          "latestFirmwareUpdate": "Última actualizació"
        }
      },
      "information": {
        "attributes": {
          "latestFirmwareUpdate": "Última actualización",
          "firmwareUpdateSource": "Origen",
          "firmwareUpdateSourceOption": {
            "mobileApp": "Aplicación móvil",
            "factory": "Fábrica"
          }
        }
      },
      "updateFirmware": "Actualización del firmware"
    },
    "logs": {
      "title": "Registros",
      "lastOperationReportUpdateDate": {
        "label": "Fecha de la última carga del informe operativo"
      },
      "noLogsFound": "No se han encontrado registros."
    },
    "additionalMetadata": {
      "title": "Metadatos adicionales",
      "options": {
        "title": "Opciones",
        "processControl": "Automatismo",
        "pumpingStation": "Estación de bombeo",
        "webServer": "Servidor Web",
        "webMimicDiagram": "Sinópticos web",
        "ipBackup": "IP de seguridad ADSL/GSM",
        "iecSlave": "IEC60870-5-104 Slave",
        "externalControlLiftStation": "Control externo de la estación de bombeo",
        "pumpingOptimization": "Optimización del bombeo",
        "dataPoints": "N° de informaciones: {value}",
        "ioModules": "Número de módulos I/O: {value}",
        "comModules": "Número de módulos COM: {value}",
        "calendars": "Número de calendarios: {value}",
        "schedules": "Número de horarios (Schedules): {value}",
        "objects": "Número de objetos: {value}",
        "allowedLocalPost": "Estaciones remotas: {value}",
        "licenceExpirationDate": "Fecha de caducidad de la licencia: {value}",
        "licenceId": "Número de licencia: {value}"
      },
      "communicationModules": {
        "title": "Módulos de comunicación"
      },
      "modules": {
        "location": "Lugar",
        "module": "Módulos"
      },
      "ioModules": {
        "title": "Módulos de entradas / salidas"
      },
      "networkInterfaceCardExtensions": {
        "title": "Extensión(es) de tarjeta de interfaz de red"
      },
      "ioCardExtensions": {
        "title": "Extensión(es) de tarjeta de E/S"
      },
      "modemCardExtensions": {
        "title": "Extensión(es) de tarjeta de módem"
      },
      "comments": {
        "title": "Comentarios"
      }
    },
    "certificate": {
      "title": "Certificado",
      "information": {
        "title": "Certificado",
        "attributes": {
          "certificateExpirationDate": "Fecha de validez del certificado",
          "lastCertificateUpdate": "Última actualización del certificado",
          "origin": "Origen del certificado",
          "origins": {
            "mobileApplication": "Aplicación móvil",
            "lxConnect": "LX CONNECT"
          }
        }
      }
    }
  },
  "empty": "No se encontró ningún equipo",
  "lifeCycleState": {
    "preprovisioned": "Presuministrado",
    "registered": "Guardado",
    "activated": "Activado",
    "disabled": "Desactivado",
    "locked": "Bloqueado"
  },
  "filters": {
    "searchByNameOrSerialNumber": "Buscar por nombre o número de serie",
    "compatibilityQuickFilters": {
      "allDevices": "Todos los equipos",
      "compatibleDevices": "Equipos compatibles",
      "incompatibleDevices": "Equipos incompatibles"
    },
    "deviceType": "Tipo",
    "selectionQuickFilters": {
      "allDevices": "Todos los equipos",
      "selectedDevices": "Equipos seleccionados",
      "unselectedDevices": "Equipos no seleccionados"
    },
    "lifecycleState": "Estado",
    "connectivity": {
      "label": "Conectividad",
      "type": "Tipo de conexión del equipo",
      "status": "Estado",
      "SHORT_LIVED": "Interrogación",
      "GOOD": "Menos de 24 horas",
      "WARN": "Más de 24 horas",
      "ERROR": "Más de 72 horas",
      "empty": "No hay estado disponible",
      "PERSISTENT": "Persistente",
      "ONLINE": "Conectado",
      "OFFLINE": "Desconectado"
    },
    "ranges": {
      "label": "Gama"
    }
  },
  "fleet": {
    "cancelSelection": "Cancelar selección",
    "selectedDevices": "No se han seleccionado equipos. | {count} equipo seleccionado | {count} equipos seleccionados",
    "addToFleet": "Añadir a una flota",
    "removeFromFleet": "Eliminar de la flota"
  },
  "deviceFound": "No se han encontrado equipos. | {count} equipo encontrado | {count} equipos encontrados",
  "action": {
    "enable": "Activar el equipo",
    "disable": "Desactivar el equipo",
    "confirm": {
      "title": "¿Desactivar el equipo?",
      "description": "¿Seguro que desea desactivar este equipo? Esta acción impedirá cualquier comunicación con la plataforma y se cancelarán todas las operaciones en curso.",
      "disable": "Desactivar"
    },
    "button": {
      "enable": "Activar",
      "disable": "Desactivar"
    },
    "delete": {
      "tooltip": "Eliminar equipo",
      "confirm": {
        "title": "Eliminación de equipo",
        "message": "Al eliminar un equipo se borrarán permanentemente todos sus datos, operaciones y telemedida."
      }
    }
  },
  "cartography": {
    "title": "Cartografía",
    "deviceMapTile": {
      "button": {
        "seeDevice": "Ver el equipo"
      }
    },
    "devicesMap": {
      "noDevices": "No hay equipos para mostrar."
    }
  },
  "globalConfiguration": {
    "automaticRenewalDelay": {
      "information": {
        "title": "Retraso automático de renovación de certificado",
        "body": "Define cuánto tiempo antes de la caducidad se renovará automáticamente el certificado del equipo."
      },
      "label": "Retraso automático de renovación de certificado",
      "values": {
        "nDay": "1 día | {n} días",
        "nMonth": "1 mes | {n} meses",
        "nYear": "1 año | {n} años"
      },
      "custom": {
        "label": "Personalizado",
        "unit": "día | días"
      },
      "error": {
        "required": "Se requiere el retraso de renovación automática",
        "minMax": "El retraso de renovación automática debe estar entre {min} y {max}"
      }
    },
    "pollingFrequency": {
      "information": {
        "title": "Frecuencia de interrogación",
        "body": "Define el intervalo de tiempo entre dos comunicaciones desde el equipo a la plataforma."
      },
      "label": "Frecuencia de interrogación",
      "values": {
        "nMinute": "1 minuto | {n} minutos",
        "nHour": "1 hora | {n} horas"
      },
      "custom": {
        "label": "Personalizado",
        "unit": "minuto | minutos"
      },
      "error": {
        "required": "La frecuencia de interrogación es obligatoria",
        "minMax": "La frecuencia de interrogación debe estar entre {min} y {max}"
      }
    }
  }
}
